import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmarSaida({ open, onClose, onConfirm }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
        <Box
          sx={{
            display: "flex",
            p: 1,
            borderRadius: 2,
            bgcolor: "rgba(211,47,47,0.12)",
            color: "error.main",
          }}
        >
          <LogoutIcon />
        </Box>
        <Typography component="span" sx={{ fontWeight: 800, fontSize: 18 }}>
          Sair da conta
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography color="text.secondary">
          Tem certeza que deseja sair? Você precisará entrar novamente para
          acessar seus sistemas.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          startIcon={<LogoutIcon />}
          sx={{ borderRadius: 2, fontWeight: 700 }}
        >
          Sair
        </Button>
      </DialogActions>
    </Dialog>
  );
}
